<template>
	<v-container fluid >
		<v-toolbar flat class="mb-6">
		<!-- <v-app-bar class="mb-6" fixed> -->	
			<v-app-bar-nav-icon :to="{ name: 'Dictionaries' }">
				<v-icon large :color="color">{{ icon }}</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>
				<div class="text-h6">{{ title }}</div>
				<div class="text-subtitle-2 font-weight-light">{{ subtitle }}</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-text-field
				v-model.trim="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
				clearable
				@click:append="onSearch"
				@keyup.enter="onSearch"
			></v-text-field>

			<!-- <template v-slot:extension>
				<v-row no-gutters>
					<v-col cols="12">
						<v-btn text small v-for="letter in alphabet_en" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
					</v-col>
					<v-col cols="12">
						<v-btn text small v-for="letter in alphabet_uk" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
					</v-col>
				</v-row>
			</template> -->
		<!-- </v-app-bar> -->
		</v-toolbar>
		<v-data-table
			v-model="selected"
			:headers="headers"
			:items="items"
			show-select
			:loading="loading"
			loading-text="Loading... Please wait"
		>
			<template v-slot:item.datereg="{ item, index }">
				<span>{{ item.datereg | formatDate }}</span>
			</template>
			<template v-slot:item.datebegin="{ item, index }">
				<span>{{ item.datebegin | formatDate }}</span>
			</template>
			<template v-slot:item.dateend="{ item, index }">
				<span>{{ item.dateend | formatDate }}</span>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-toolbar elevation="0" dense color="transparent">
					<z-detail v-model="item">
						<!-- <template v-slot:activator="props">
							<v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
						</template> -->
					</z-detail>
					<!-- <z-confirm-delete 
						:activator-tooltip-text="$vuetify.lang.t('$vuetify.delete')"
						@ok="onDelete(item)"
					></z-confirm-delete> -->
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
						</template>
						<v-list>
							<z-detail v-model="item" @ok="onEdit(item, $event)">
								<template v-slot:activator="props">
									<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog }">
										<v-list-item-icon>
											<v-icon>mdi-pencil</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Редагувати</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</z-detail>
							
							<v-divider></v-divider>

							<!-- <v-subheader>Ідентифікація</v-subheader>

							<v-list-item @click="onIdentification(item, 'number')">
								<v-list-item-icon>
									<v-icon>mdi-alpha-n-box</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>За номером</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item @click="onIdentification(item, 'vin')">
								<v-list-item-icon>
									<v-icon>mdi-alpha-v-box</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>За VIN-кодом</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
 -->
							<!-- <v-divider></v-divider> -->

							<z-confirm-delete @ok="onDelete(item)">
								<template v-slot:activator="props">
									<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog }">
										<v-list-item-icon>
											<v-icon>mdi-delete</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Видалити</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</z-confirm-delete>
						</v-list>
					</v-menu>
				</v-toolbar>

				
			</template>
		</v-data-table>

		<z-detail tooltip="create" @ok="onCreate">
			<template v-slot:activator="props">
				<v-fab-transition>
					<v-btn v-bind="props.attrs" v-on="{...props.dialog}"
						color="primary"
						dark
						fixed
						bottom
						right
						fab
						class="mb-8 mr-8"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-fab-transition>
			</template>
		</z-detail>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zDetail from '@/views/dialogs/details/InsuranceIndicator'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete3'

export default {
	name: 'InsuranceIndicator',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail,
		zConfirmDelete,
	},
	data: () => ({
		title: 'Показники діяльності страховиків',
		subtitle: 'Основні показники діяльності страховиків',
		icon: 'mdi-script-text',
		color: 'green darken-1',
		loading: false,

		search: null,

		selected: [],
		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			//{ text: 'Порядковий номер', value: 'nop', sortable: true},
			//{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			//{ text: 'Опис', value: 'description', sortable: true},
			/* { text: 'Дата реєстрації', value: 'datereg', sortable: true},
			{ text: 'Термін дії з', value: 'datebegin', sortable: true},
			{ text: 'Термін дії по', value: 'dateend', sortable: true},
			{ text: 'Тип', value: 'type.name', sortable: true},
			{ text: 'Категорія', value: 'category.name', sortable: true},
			{ text: 'Напрямок', value: 'direction.name', sortable: true},
			{ text: 'Джерело даних', value: 'source.name', sortable: true},
			{ text: 'Валюта', value: 'currency.name', sortable: true},
			{ text: 'Продавець', value: 'seller.name', sortable: true},
			{ text: 'Кількість продуктів', value: 'productsCount', sortable: true},
			//{ text: 'URL сайту', value: 'url', sortable: true},
			{ text: 'Користувач', value: 'user.name', sortable: true}, */
			{ text: '', value: 'actions', sortable: false },
		],

		items: [],
	}),
	
	computed: {
		
	},

	created () {
		//this.onSearch()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		//--------------------------------------------------------------------

		onSearch() {
			//console.log(this.$options.name, 'loadModels','item1', item1)

			this.selected = [];

			//Формування параметрів
			//let params = { search: this.search }
			let params = {}
			if(this.search) params['search'] = this.search
			
			/* let that = this
			this.loading = true
			axios.get('/insurance/indicator', { params: params }).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading = false)); */
		},

		onCreate(item) {
			//console.log(this.$options.name, 'onCreate', 'item', item)

			this.items.push(item)
		},

		onEdit(selected, item) {
			//console.log(this.$options.name, 'onEdit', 'selected', selected)
			//console.log(this.$options.name, 'onEdit', 'item', item)

			const index = this.items.indexOf(selected)
			this.items.splice(index, 1, item)
		},

		onDelete(item) {
			//console.log(this.$options.name, 'onDelete', 'item', item)
			const index = this.items.indexOf(item)
			this.items.splice(index, 1);

			/* let that = this
			this.loading = true
			axios.delete(`/insurance/indicator/${item.id}`).then(response => {
				//console.log(that.$options.name, 'onDelete','response.data', response.data)
				const index = that.items.indexOf(item)
				that.items.splice(index, 1);
			}, error => { console.log('error', error) }
			).finally(() => (this.loading = false)); */

		},
	},
}
</script>